import api from './api';
import { Cliente, Contacto, Municipio, Departamento, PaginatedResponse } from '../types';

class ClientsService {
  // Clientes
  async getClientes(page = 1, limit = 100, search?: string, status?: 'all' | 'active' | 'inactive'): Promise<PaginatedResponse<Cliente>> {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    
    if (search) {
      params.append('search', search);
    }

    if (status && status !== 'all') {
      params.append('status', status);
    }

    const response = await api.get<PaginatedResponse<Cliente>>(`/clientes?${params}`);
    return response.data;
  }

  async getClienteById(id: number): Promise<Cliente> {
    const response = await api.get<Cliente>(`/clientes/${id}`);
    return response.data;
  }

  async createCliente(cliente: Omit<Cliente, 'id' | 'createdAt' | 'updatedAt' | 'isActive'>): Promise<Cliente> {
    const response = await api.post<Cliente>('/clientes', cliente);
    return response.data;
  }

  async updateCliente(id: number, cliente: Partial<Cliente>): Promise<Cliente> {
    const response = await api.put<Cliente>(`/clientes/${id}`, cliente);
    return response.data;
  }

  async deleteCliente(id: number): Promise<void> {
    await api.delete(`/clientes/${id}`);
  }

  // Contactos
  async createContacto(contacto: Omit<Contacto, 'id' | 'createdAt' | 'updatedAt' | 'isActive'>): Promise<Contacto> {
    const response = await api.post<Contacto>('/contactos', contacto);
    return response.data;
  }

  async updateContacto(id: number, contacto: Partial<Contacto>): Promise<Contacto> {
    const response = await api.put<Contacto>(`/contactos/${id}`, contacto);
    return response.data;
  }

  async deleteContacto(id: number): Promise<void> {
    await api.delete(`/contactos/${id}`);
  }

  // Municipios
  async getMunicipios(): Promise<Municipio[]> {
    const response = await api.get<Municipio[]>('/municipios');
    return response.data;
  }

  async getDepartamentos(): Promise<Departamento[]> {
    const response = await api.get<Departamento[]>('/departamentos');
    return response.data;
  }
}

const clientsService = new ClientsService();
export default clientsService;